module.exports = __webpack_public_path__ + "assets/cxbh.5f3d737e.svg";